export default __webpack_public_path__ + "static/media/champagner.c15b6b78.png";